module.exports = __webpack_public_path__ + "static/fonts/Fact-MediumItalic.b05193e.ttf";